import { NgModule, inject, provideEnvironmentInitializer } from '@angular/core';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache, ApolloLink } from '@apollo/client/core';
import { SetContextLink } from '@apollo/client/link/context';
import { environment } from 'src/environments/environment';

export class ApolloConfigFactory {
  static create(httpLink: HttpLink) {
    
    // SAFE IMPLEMENTATION: Do not spread or reference prevContext.headers
    const contextLink = new SetContextLink((_, prevContext): any => {
      const token = environment.qraphapiToken;

      // Create a clean, isolated plain JavaScript dictionary
      const customHeaders: Record<string, string> = {
        'Accept': 'charset=utf-8'
      };

      if (token) {
        customHeaders['Authorization'] = `Bearer ${token}`;
      }

      // Return custom headers independently. 
      // Apollo safely appends these to the underlying request behind the scenes.
      return {
        headers: customHeaders
      };
    });

    return {
      link: ApolloLink.from([
        contextLink,
        httpLink.create({
          uri: environment.graphcmsapiurl
        })
      ]),
      cache: new InMemoryCache()
    };
  }
}

@NgModule({
  imports: [],
  providers: [
    Apollo,
    {
      provide: APOLLO_OPTIONS,
      useFactory: ApolloConfigFactory.create,
      deps: [HttpLink]
    },
    provideEnvironmentInitializer(() => {
      inject(Apollo);
    })
  ]
})
export class GraphQLModule {}

